/**
 * @generated SignedSource<<bc329372f9b346f0cbe01b7f0724ceb3>>
 * @relayHash 4a2a6e866128a40badb1b2179a63d891
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455

import type { ConcreteRequest } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type useReactionMutationsAddReactionMutation$variables = {
  cloudId: string;
  containerId: AGG$Long;
  containerType: ContainerType;
  contentId: AGG$Long;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type useReactionMutationsAddReactionMutation$data = {
  readonly confluence_addReaction: {
    readonly ari: string | null | undefined;
    readonly containerAri: string | null | undefined;
    readonly emojiId: string | null | undefined;
  } | null | undefined;
};
export type useReactionMutationsAddReactionMutation = {
  response: useReactionMutationsAddReactionMutation$data;
  variables: useReactionMutationsAddReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiId"
},
v6 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "containerType",
            "variableName": "containerType"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentType",
            "variableName": "contentType"
          },
          {
            "kind": "Variable",
            "name": "emojiId",
            "variableName": "emojiId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceReactionPayload",
    "kind": "LinkedField",
    "name": "confluence_addReaction",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "ari"
      },
      {
        "kind": "ScalarField",
        "name": "containerAri"
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useReactionMutationsAddReactionMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "useReactionMutationsAddReactionMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "4a2a6e866128a40badb1b2179a63d891",
    "id": "1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455",
    "metadata": {},
    "name": "useReactionMutationsAddReactionMutation",
    "operationKind": "mutation",
    "text": "mutation useReactionMutationsAddReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_addReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
  }
};
})();

(node as any).hash = "547036fa0d9c77c600330473576f635a";

export default node;
